import React from 'react'
import {
  Paper,
  Avatar,
  Typography,
  Button,
  CircularProgress,
  Box
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { useTranslation } from 'react-i18next'

type UserProfileProps = {
  firstName: string
  lastName: string
  email: string
  onEditProfile: () => void
  isLoading?: boolean
}

const UserProfile: React.FC<UserProfileProps> = ({
  firstName,
  lastName,
  email,
  onEditProfile,
  isLoading = false
}) => {
  const { t } = useTranslation()
  return (
    <Paper
      elevation={3}
      sx={{
        padding: 4,
        textAlign: 'center',
        position: 'relative',
        mt: '-140px',
        width: '280px',
        height: '407px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '10px'
      }}
    >
      {isLoading ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Avatar
            src='/avatar.png'
            alt='User Avatar'
            sx={{
              width: 100,
              height: 100,
              margin: '0 auto 16px'
            }}
          />
          <Typography
            variant='h2'
            sx={{
              mt: 3,
              wordBreak: 'break-word',
              textAlign: 'center',
              maxWidth: '100%',
              whiteSpace: 'normal'
            }}
          >
            {firstName} {lastName}
          </Typography>
          <Typography
            variant='body1'
            sx={{
              mt: 1,
              maxWidth: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              wordBreak: 'break-all'
            }}
          >
            {email}
          </Typography>

          <Button
            variant='contained'
            sx={{
              mt: 5,
              width: '190px',
              height: '36px',
              gap: '10px',
              borderRadius: '6px',
              '&.MuiButton-contained': {
                borderColor: 'primary.main'
              },
              fontFamily: 'Inter',
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '16px',
              textAlign: 'left'
            }}
            onClick={onEditProfile}
          >
            <EditIcon sx={{ fontSize: 18 }} />
            {t('myAccount.profile.editProfile')}
          </Button>
        </>
      )}
    </Paper>
  )
}

export default UserProfile
